import Vue from 'vue';
if(document.getElementById('comments')){
    let comments = new Vue({
        el:"#comments",
        data:{
            items:[],
            page:1,
            pageCount:1
        },
        methods:{
            fetch() {
                let self = this;
                $.ajax({
                    url: '/api/v1/lection',
                    dataType: "json",
                    data: {page:self.page},
                    success: function (data) {
                        if(append === true){
                            $.each(data.items,function (i,item) {

                                self.lections.items.push(item);

                            });

                        } else {

                            self.lections = data;
                            self.pageCount = data._meta.pageCount;
                            self.page = 1;

                        }

                    },
                    fail: function () {

                        throw new Error('Ошибка получении данных');

                    }
                });
            }
        }
    });
}